export default "__VITE_ASSET__D52DeiAH__"